const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_wosol-future/artifacts/mxr41czc_WosolTech%20logo.png";

import { Link } from "react-router-dom";

// The uploaded brand asset already contains the wordmark + tagline.
// We display it as-is and skip a duplicate side wordmark.
export default function Logo({ size = 72, withText = false }) {
  return (
    <Link
      to="/"
      className="flex items-center gap-3 group"
      data-testid="brand-logo"
      aria-label="Wosol Tech"
    >
      <span
        className="relative inline-flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-105"
        style={{ width: size, height: size }}
      >
        <span
          className="absolute inset-[-6px] rounded-full opacity-50 group-hover:opacity-100 transition-opacity"
          style={{
            background:
              "radial-gradient(circle, rgba(0,240,255,0.4) 0%, rgba(0,240,255,0) 65%)",
            filter: "blur(10px)",
          }}
          aria-hidden="true"
        />
        <img
          src={LOGO_URL}
          alt="Wosol Tech"
          className="relative w-full h-full object-contain"
          style={{ background: "transparent" }}
        />
      </span>
      {withText && (
        <span className="font-display tracking-tight leading-none flex flex-col gap-1">
          <span className="text-lg sm:text-xl font-extrabold">
            <span className="text-white">WOSOL</span>
            <span className="text-[#00F0FF] wt-glow-text">TECH</span>
          </span>
        </span>
      )}
    </Link>
  );
}
